import { useEffect } from "react";

export function useAsyncEffect(fn, dp, ret) {
  if (typeof fn !== "function") {
    console.log("fn", fn);
    debugger;
  }
  useEffect(() => {
    const asynFn = async () => await fn();
    try {
      asynFn();
    } catch (e) {
      console.log(e);
    }
    return ret?.();
  }, dp);
}
